module.exports = __webpack_public_path__ + "img/uneal.2e156a59.png";